import styled from 'styled-components'
import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '../Grid'
import { clickable, flexbox } from '../../styles'
import { StyledGradientProps } from '../../styles/types'
import { space } from '../../styles/properties/space'

const LinearGradient = styled(Grid)`
    ${space}
    ${flexbox}
    ${(props): string =>
        `background-image: linear-gradient(to top, ${props.gradient[0]}, ${props.gradient[1]});`}
    ${clickable}
`
const Gradient: FunctionComponent<StyledGradientProps> = ({
    children,
    alignBottom,
    gradient = ['rgba(0, 0, 0, 0.6)', 'rgba(0, 0, 0, 0)'],
    padding,
    expand,
    testID,
}): ReactElement => {
    return (
        <Grid alignBottom={alignBottom} testID={testID}>
            <LinearGradient gradient={gradient} padding={padding} noExpand={!expand}>
                {children}
            </LinearGradient>
        </Grid>
    )
}

export default Gradient
